var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill-rule":"evenodd","fill":"none"}},[_c('path',{attrs:{"d":"M-1.687-1.687h23.374v23.374H-1.687V-1.687z"}}),_c('path',{attrs:{"d":"M18.766 10L3.183 19.739V.259L18.766 10z","fill-rule":"nonzero","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }